(function () {
  function closeVideoModal() {
    var videos = document.querySelector('.cs-legacy-page--video-gallery .videos, .masklayer + .videos, .videos');
    var mask = document.querySelector('.cs-legacy-page--video-gallery .masklayer, .masklayer');
    var video = document.getElementById('video');

    if (videos) {
      videos.style.display = 'none';
      videos.innerHTML = '';
    }
    if (mask) mask.style.display = 'none';
    if (video && typeof video.pause === 'function') video.pause();
  }

  window.close1 = closeVideoModal;

  function initVideoGallery() {
    var items = document.querySelectorAll('.videolist');
    if (!items.length) return;

    var videos = document.querySelector('.videos');
    var mask = document.querySelector('.masklayer');
    if (!videos || !mask) return;

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var img = item.getAttribute('vpath');
        var video = item.getAttribute('ipath');
        if (!video) return;

        videos.innerHTML =
          '<iframe id="video" class="video" src="' +
          video +
          '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>' +
          '<img onclick="close1()" class="vclose" src="https://cdn.shopify.com/s/files/1/0047/0247/0190/files/p_dz-icon.png?v=1677816519" width="25" height="25" alt="Close">';
        videos.style.display = 'block';
        mask.style.display = 'block';
      });
    });

    mask.addEventListener('click', function (event) {
      if (event.target === mask) closeVideoModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoGallery);
  } else {
    initVideoGallery();
  }
})();
